import { inject, Injectable, signal } from '@angular/core';
import { EFilingHttpService } from '../services/e-filing-http.service';
import { ToastService } from '../services/toast.service';
import { type ParentCompany } from '../models/parent-company';

@Injectable({ providedIn: 'root' })
export class ParentCompanyStore {
	private readonly http = inject<EFilingHttpService>(EFilingHttpService);
	private readonly toastService = inject<ToastService>(ToastService);

	public readonly parentCompanies = signal<ParentCompany[]>([]);

	public readonly loading = signal<boolean>(false);

	public load(reload = false): void {
		if (!reload && this.parentCompanies().length > 0) return;

		this.loading.set(true);

		this.http.getParentCompanies().subscribe({
			next: (data) => {
				this.parentCompanies.set(data);
				this.loading.set(false);
			},
			error: () => {
				this.toastService.showErrorToast(
					'Failed to load parent companies'
				);
				this.loading.set(false);
			}
		});
	}
}
